<mat-sidenav-container>
  <mat-sidenav
    class="main row create_campaign"
    #sidenav
    mode="over"
    position="end"
    [opened]="userState.openPropertySearchSheetSubject$ | async"
    disableClose
  >
    <div class="sliding-sheet-header">
      <h4>{{ heading }}</h4>
      <button type="button" (click)="closeSheet()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="report-main analyse-property">
      <h5 class="mb-4">{{ content }}</h5>
      <h6>Find by Address</h6>
      <div class="row">
        <div class="col-md-8 col-sm-12 col-12 search-input">
          <div class="search_base">
            <img src="../../assets/images/search_icon.png" alt="search" />
            <input
              type="text"
              class="form-control"
              #searchField
              [(ngModel)]="autoCompleteInput"
              placeholder="Search address, ZIP, neighborhood, school district"
              name="autocompleteInput"
              required
              aria-label="enter address"
            />
          </div>
        </div>
      </div>

      <!-- <app-search *ngIf="!showPropertyDetailsCard"></app-search> -->
      <div class="clearfix"></div>
      <div class="mt-2">
        <a class="advance" (click)="toggleBottomSection()">
          {{ showBottomSection ? 'Hide Advanced Search' : 'Advanced Search' }}
        </a>
      </div>
      <div *ngIf="showBottomSection">
        <h6 class="pt-3 pb-2">Search by Address</h6>
        <app-search-by-address (propertySelected)="onPropertySelected($event)"></app-search-by-address>
        <div class="clearfix"></div>
      </div>
      <app-search-list source="dashboard" (propertySelected)="onPropertySelected($event)"></app-search-list>
      <div class="row">
        <div class="col-12 mt-3">
          <button
            mat-flat-button
            color="primary"
            class="primary mr-2"
            *ngIf="selectedProperty"
            (click)="analyzeProperty()"
          >
            Analyze Property
          </button>
        </div>
      </div>
    </div>

    <div class="section-in-progress" *ngIf="isLoadingCreateReport">
      <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
      Please wait while we load
    </div>
    <div class="slidesheetcontent"></div> </mat-sidenav
></mat-sidenav-container>
